import api from "../config/api";

/** The entities the API can synchronise, one endpoint each. */
export type SyncEntity =
  "coders" | "supervisors" | "games" | "codings" | "supervisions";

/** How long a sync is given: the codings pass reads several thousand rows from AIA. */
export const SYNC_TIMEOUT_MS = 600000;

export interface SyncEntityResponse {
  success: boolean;
  message?: string;
  stats?: Record<string, number> | null;
  errors?: unknown[];
  /** Assignment changes the sync noticed but deliberately did not apply. */
  change_detection?: { changes_detected?: number } | null;
  total_changes_detected?: number | null;
  coding_requests_generation?: { contractsCreated?: number } | null;
}

/**
 * Synchronises one entity.
 *
 * The single way any page asks for a sync. Each entity has one endpoint, and that
 * endpoint does the whole job for it — including detecting the assignment changes it
 * must not apply on its own. Before this, a codings sync did different work depending
 * on which page had asked: the Contrats page called a route that detected coder
 * changes, Codages and the dashboard called one that did not, so whether a change was
 * ever noticed came down to which button someone happened to press.
 */
export const syncEntity = (entity: SyncEntity) =>
  api
    .post<SyncEntityResponse>(
      `/api/sync/${entity}`,
      {},
      {
        timeout: SYNC_TIMEOUT_MS,
      },
    )
    .then((response) => response.data);
